import { render } from "./sousOrgaMeraki.vue?vue&type=template&id=292bfae9"
import script from "./sousOrgaMeraki.vue?vue&type=script&lang=ts"
export * from "./sousOrgaMeraki.vue?vue&type=script&lang=ts"
script.render = render

export default script